import loadable from '@loadable/component'

export default {
    '/:type/open/oneQuestionDayList': loadable(() => import('./oneQuestionDayList')),
    '/:type/open/oneQuestionDayDetail': loadable(() => import('./oneQuestionDayDetail')),
}
